import { useQuery } from 'react-query';
import axios from 'axios';
import { commonHeaders } from '../../../constants/HeadersAPI';
import { BranchAPI } from '../../../constants/API';

export type BranchQueueItemDto = {
  id: number;
  queueName: string;
  terminalName: string;
  monitorName: string;
  /** Ориентация табло для очереди (если бэкенд вернёт это поле). */
  tabloOrientation?: 'VERTICAL' | 'HORIZONTAL' | null;
};

/** Уникальные имена очередей по филиалам текущего пользователя (для выбора при создании рабочего места). */
export const useGetQueuesForCurrentUser = (enabled: boolean = true) => {
  const {
    data: queues = [],
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<BranchQueueItemDto[]>(
    ['branches', 'queues', 'for-current-user'],
    () =>
      axios
        .get(BranchAPI.getQueuesForCurrentUser, commonHeaders())
        .then((r) => r.data)
    ,
    { enabled }
  );

  const normalizedQueues = queues.map((q) => ({
    ...q,
    tabloOrientation: q.tabloOrientation ?? 'HORIZONTAL',
  }));

  const queueNames = Array.from(
    new Set(normalizedQueues.map((q) => q.queueName).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b));

  return { queueNames, queues: normalizedQueues, isLoading, isError, error, refetch };
};
